import styled from 'styled-components';
export var Label = styled.label.withConfig({
  displayName: "style__Label",
  componentId: "fpocx6-0"
})(["position:relative;display:inline-block;vertical-align:middle;background-color:#e9eded;line-height:20px;font-size:14px;font-weight:400;margin-bottom:0;left:5px;white-space:nowrap;"]);
export var PanelLabel = styled.div.withConfig({
  displayName: "style__PanelLabel",
  componentId: "fpocx6-1"
})(["height:25px;line-height:100%;width:", ";margin:auto;margin-left:10px;font-weight:", ";color:rgba(14,19,24,0.9);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:left;z-index:", ";order:", ";min-width:100%;"], function (props) {
  return props.width ? props.width : '100%';
}, function (props) {
  return props.bold ? 'bold' : 'normal';
}, function (props) {
  return props.price ? '98' : '99';
}, function (props) {
  return props.order ? props.order : '0';
});
export var Container = styled.label.withConfig({
  displayName: "style__Container",
  componentId: "fpocx6-2"
})(["padding:15px;width:100%;margin-bottom:20px;border:1px solid transparent;border-radius:4px;color:", ";background-color:white;border-color:", ";"], function (props) {
  return props.type == 'error' ? '#a94442' : '#000';
}, function (props) {
  return props.type == 'error' ? '#ebccd1;' : '#9de042';
});